module.exports = __WEBPACK_EXTERNAL_MODULE_159__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/core-client/js/core-client/utils/Deferred"
// module id = 159
// module chunks = 2